import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import {changeSetting} from 'common/actions/settings';
import {getAgencies, getServices} from 'ondemand/selectors';
import {fetchAgenciesIfNeeded} from 'ondemand/actions/agency';
import {fetchServicesIfNeeded} from 'ondemand/actions/service';

import queryString from 'query-string';

class HashParser extends React.Component {
  static displayName = 'HashParser';

  static propTypes = {
    agencies: PropTypes.object,
    services: PropTypes.object,
    dispatch: PropTypes.func,
    location: PropTypes.shape({
      search: PropTypes.string,
      hash: PropTypes.string,
    }),
  };

  componentDidMount() {
    const agencyNames = this._parseAgencyNames();
    this.props.dispatch(fetchAgenciesIfNeeded()).then(() => {
      if (agencyNames.length === 1 && this.props.agencies[agencyNames[0]]) {
        const agencyName = agencyNames[0];
        this.props.dispatch(changeSetting('agencyId', agencyName));

        const serviceId = queryString.parse(this.props.location.search).service;
        this.props.dispatch(fetchServicesIfNeeded(agencyName)).then(() => {
          if (serviceId && this.props.services[serviceId]) {
            this.props.dispatch(changeSetting('serviceId', serviceId));
          }
        });
      }
    });
  }

  _parseAgencyNames = () => {
    const agencyNames = queryString.parse(this.props.location.search).agency;
    if (agencyNames) {
      return agencyNames.split(',');
    } else if (this.props.location.hash && this.props.location.hash.startsWith('#ride-request?')) {
      const query = this.props.location.hash.split('?')[1];
      const part = query.split('&').find(p => p.startsWith('agencies='));
      if (part !== undefined) {
        return part.split('=')[1].split(',');
      }
    }
    return [];
  };

  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  agencies: getAgencies(state),
  services: getServices(state),
});

export default connect(mapStateToProps)(HashParser);



// WEBPACK FOOTER //
// ./src/ondemand/containers/HashParser.js